module.exports = __webpack_public_path__ + "fonts/TTHovesRegular.a1102b0a.ttf";